const getters = {
  nativeLoginStatus: state => state.user.nativeLoginStatus,
  userInfo: state => state.user.userInfo,
}
export default getters
